import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MessageCircle, CalendarCheck } from 'lucide-react';
import { buildWhatsAppLink } from '@/components/services/servicesData';

// cta: { title, text, primaryLabel, waLabel, waMessage, waPrimary }
export default function LocaleCTA({ cta, contactTo }) {
  const wa = (
    <a
      href={buildWhatsAppLink(cta.waMessage)}
      target="_blank"
      rel="noopener noreferrer"
      className={cta.waPrimary
        ? 'inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/90 transition-all duration-300 hover:shadow-lg hover:shadow-primary/25'
        : 'inline-flex items-center gap-2 px-8 py-4 border border-primary/40 text-primary font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/10 transition-all duration-300'}>
      <MessageCircle className="w-4 h-4" />
      {cta.waLabel}
    </a>
  );
  const primary = (
    <Link
      to={contactTo}
      className={cta.waPrimary
        ? 'inline-flex items-center gap-2 px-8 py-4 border border-primary/40 text-primary font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/10 transition-all duration-300'
        : 'inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground font-inter font-semibold text-sm tracking-wider uppercase rounded-xl hover:bg-primary/90 transition-all duration-300 hover:shadow-lg hover:shadow-primary/25'}>
      <CalendarCheck className="w-4 h-4" />
      {cta.primaryLabel}
    </Link>
  );
  return (
    <section className="relative py-24 px-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-background" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.8 }}
        className="max-w-3xl mx-auto text-center relative">
        <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-4">{cta.title}</h2>
        <p className="text-muted-foreground font-inter leading-relaxed mb-10 max-w-xl mx-auto">{cta.text}</p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          {cta.waPrimary ? <>{wa}{primary}</> : <>{primary}{wa}</>}
        </div>
      </motion.div>
    </section>
  );
}